export const RECENT_CACHE_TTL_MS = 5 * 60 * 1000;
export const RECENT_CACHE_STORAGE_PREFIX = 'recent_submissions_cache_v1';

export const toDateFromUnknown = (value) => {
  if (!value) return null;
  if (typeof value?.toDate === 'function') {
    const date = value.toDate();
    return Number.isNaN(date?.getTime?.()) ? null : date;
  }
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === 'number') {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  if (typeof value?.seconds === 'number') {
    const date = new Date(value.seconds * 1000);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  if (typeof value === 'string') {
    const parsed = Date.parse(value);
    if (!Number.isNaN(parsed)) return new Date(parsed);
  }
  return null;
};

export const formatDateForRecent = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  const date = toDateFromUnknown(value);
  if (!date) return '';
  return date.toISOString().slice(0, 10);
};

export const getSortTimestamp = (value) => {
  const date = toDateFromUnknown(value);
  return date ? date.getTime() : Number.NEGATIVE_INFINITY;
};

export const getYearFromDateValue = (value) => {
  const date = toDateFromUnknown(value);
  return date ? String(date.getFullYear()) : null;
};

export const isInYearOrUnknown = (value, targetYear) => {
  const year = getYearFromDateValue(value);
  if (!year) return true;
  return String(year) === String(targetYear);
};

export const sortAndTrimRecent = (items, max = 20) => {
  return sortRecentItems(items)
    .slice(0, max)
    .map(({ sortTs, rawDate, ...item }) => item);
};

export const sortRecentItems = (items) => {
  return [...items].sort((a, b) => {
    if (a.sortTs !== b.sortTs) return b.sortTs - a.sortTs;
    const aKey = `${a.seasonId || 'legacy'}:${a.matchId || a.id || ''}`;
    const bKey = `${b.seasonId || 'legacy'}:${b.matchId || b.id || ''}`;
    return aKey.localeCompare(bKey);
  });
};

export const dedupeByKey = (items, keyFn) => {
  const seen = new Set();
  return items.filter((item) => {
    const key = keyFn(item);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
